module.exports = __webpack_public_path__ + "img/EMSV2.e44b9afe.png";